import { render, staticRenderFns } from "./SimpleRegionStatistics.vue?vue&type=template&id=3168f80a&scoped=true"
import script from "./SimpleRegionStatistics.vue?vue&type=script&lang=js"
export * from "./SimpleRegionStatistics.vue?vue&type=script&lang=js"
import style0 from "./SimpleRegionStatistics.vue?vue&type=style&index=0&id=3168f80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168f80a",
  null
  
)

export default component.exports